import React from 'react'
import { LibraryItem } from '../../types/LibraryItem'
import { LibraryCard } from './LibraryCard'

export const LibraryList = ({libraryItem,type}:Props) => {
    return(
        <div className='grid grid-cols-3 gap-y-5 mt-3 gap-x-6'>
            {libraryItem.map(item => (
                <div key={item.id}>
                    <LibraryCard type={type} item={item}/>
                </div>
            ))}
        </div>
    )
}

interface Props {
    libraryItem:LibraryItem[]
    type:"ebooks"|"hints"|"materials"|"videos"
}
